import BaseDatePicker from "../../../../components/ui/BaseDatePicker";
import BaseTextField from "../../../../components/ui/BaseTextField";
import FieldLabel from "../../../../components/ui/FieldLabel";

import { useDispatch, useSelector } from "react-redux";
import dayjs from "dayjs";
import {
  updateWorkOrderForm,
  updateWorkOrderFormValidation,
} from "../../../../store/workOrder/workOrderSlice";
import { getTimeZoneAbbreviation } from "../../../../utils/getTimeZoneAbbreviation";

const HardStart = () => {
  const dispatch = useDispatch();
  const schedule = useSelector((state) => state.workOrder.scheduling.schedule);
  const workOrderFormValidation = useSelector(
    (state) => state.workOrder.workOrderFormValidation
  );

  const handleChange = (name, value) => {
    dispatch(
      updateWorkOrderForm({
        step: "scheduling",
        data: {
          schedule: {
            [name]: value,
          },
        },
      })
    );

    if (name === "orderStartDate" && value) {
      dispatch(
        updateWorkOrderFormValidation({
          fieldName: "orderStartDate",
          data: false,
        })
      );
    } else if (name === "orderStartDate" && !value) {
      dispatch(
        updateWorkOrderFormValidation({
          fieldName: "orderStartDate",
          data: true,
        })
      );
    }
    if (name === "orderStartTime" && value) {
      dispatch(
        updateWorkOrderFormValidation({
          fieldName: "orderStartTime",
          data: false,
        })
      );
    } else if (name === "orderStartTime" && !value) {
      dispatch(
        updateWorkOrderFormValidation({
          fieldName: "orderStartTime",
          data: true,
        })
      );
    }
  };

  const shouldDisableTime = (value, view) => {
    if (schedule?.timeZone) {
      const selectedDate = dayjs(schedule?.orderStartDate);

      const currentTimeInZone = dayjs().tz(schedule?.timeZone);

      const currentHour = currentTimeInZone.hour();
      const currentMinute = currentTimeInZone.minute();

      const valueDate = dayjs(value);
      const isSameDay = selectedDate.isSame(currentTimeInZone, "day");

      if (selectedDate.isBefore(currentTimeInZone, "day")) {
        return true;
      }

      if (isSameDay) {
        if (view === "hours" && valueDate.hour() < currentHour) {
          return true;
        }

        if (view === "minutes") {
          if (valueDate.hour() < currentHour) return true;
          if (
            valueDate.hour() === currentHour &&
            valueDate.minute() < currentMinute
          ) {
            return true;
          }
        }
      }

      return false;
    }
  };

  return (
    <div className="grid grid-col-2 gap-y-4">
      <div className="col-span-2 bg-[#F2FAFF] py-3 px-4 rounded-md my-3">
        <div className="flex items-center">
          <i className="fa-solid fa-circle-info text-[#7AC7FF] text-lg"></i>

          <div className="ml-2">
            <p className="font-medium ">
              Supplier for this type of work order must reach 15 minutes before
              the work order schedule time.
            </p>
          </div>
        </div>
      </div>
      <div className="col-span-2 grid grid-cols-12 sm:gap-y-0 gap-y-2 flex items-start">
        <div className="w-full lg:col-span-5 col-span-12">
          <FieldLabel label="Date" requirement="required" fullHeight={false} />
          <BaseDatePicker
            className="h-10"
            type="date"
            name="orderStartDate"
            minDate={schedule.timeZone ? dayjs(dayjs().tz(schedule.timeZone).format("YYYY-MM-DD")) : dayjs().startOf("day")}
            // null, not dayjs("") — an Invalid Date makes MUI render the field
            // in its error state before the user has touched anything.
            value={schedule.orderStartDate ? dayjs(schedule.orderStartDate) : null}
            onChange={(e) =>
              handleChange(
                "orderStartDate",
                dayjs(e).utcOffset(0, true).format("YYYY-MM-DDTHH:mm:ss")
              )
            }
          />
          {workOrderFormValidation.orderStartDate && (
            <p className="text-xs text-red-600 mt-1.5">Date is required</p>
          )}
        </div>
        {/* Offset by the label row above so it lines up with the inputs. */}
        <p className="mx-9 lg:mt-9 text-dark lg:col-span-2 col-span-12 text-center">
          at
        </p>
        <div className="w-full lg:col-span-5 col-span-12">
          <FieldLabel label="Time" requirement="required" fullHeight={false} />
          <BaseDatePicker
            disabled={!schedule.orderStartDate}
            className="h-10"
            name="orderStartTime"
            type="time"
            value={schedule.orderStartTime ? dayjs(schedule.orderStartTime) : null}
            onChange={(e) => {
              handleChange(
                "orderStartTime",
                dayjs(e).utcOffset(0, true).format("YYYY-MM-DDTHH:mm:ss")
              );
            }}
            // defaultValue={fiveAM}
            // minTime={minTime}
            shouldDisableTime={shouldDisableTime}
          />
          {workOrderFormValidation.orderStartTime && (
            <p className="text-xs text-red-600 mt-1.5">Time is required</p>
          )}
        </div>
      </div>

      <div className="col-span-2 grid grid-cols-2 flex items-center">
        <div className="w-full lg:col-span-1 col-span-2 pr-[118px]">
          <BaseTextField
            fullHeight={false}
            fullWidth
            label="Time Zone"
            labelShrink={false}
            required={true}
            disabled
            optional={false}
            name="timeZone"
            value={getTimeZoneAbbreviation(schedule.timeZone || "")}
            onChange={(e) => handleChange("timeZone", e.target.value)}
          />
        </div>
        <p className="mx-10 text-dark sm:block hidden"></p>
        <div className="flex items-center w-full lg:mt-6 mt-2">
          <p className="">Time zone is set according to the work location.</p>
        </div>
      </div>
    </div>
  );
};

export default HardStart;
